/**
 * Display labels per realtime detection kind, for the places that render a
 * kind name in prose (incident titles, snooze log lines). Kept apart from
 * the map layer's KIND_META so it can be used by pages that never touch
 * Mapbox.
 */

export const REALTIME_KIND_LABELS: Record<string, string> = {
  hotspot: "Hotspot",
  lightning: "Lightning",
  hazard: "Hazards incident",
  ignition: "Ignition point",
  burnt_area: "Burnt area",
};

export const realtimeKindLabel = (kind: string): string =>
  REALTIME_KIND_LABELS[kind] ?? kind.replace(/_/g, " ");
